
export class Address {

    public Display: string;
    public Address: string;
    public City: string;
    public PostalCode: string;
    public Country: string;

    public static extractData(response: any): Array<Address> {

        const body = response.json();
        const result = new Array<Address>();
        for (const entry of body) {
            const addr = new Address();
            result.push(Object.assign(addr, entry));
        }

        return result;
    }
}
